var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTimeSliderThumb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "48pzgz5z9a",
  width: "143.8%",
  height: "143.8%",
  x: "-21.9%",
  y: "-15.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
})), /*#__PURE__*/React.createElement("circle", {
  id: "qer9p8rxwb",
  cx: 16,
  cy: 16,
  r: 16
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 2)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#qer9p8rxwb",
  fill: "#000",
  filter: "url(#48pzgz5z9a)"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#qer9p8rxwb",
  className: "slider-thumb-center"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#177991",
  d: "M20 2c8.837 0 16 7.163 16 16s-7.163 16-16 16S4 26.837 4 18 11.163 2 20 2m0 1.5C11.992 3.5 5.5 9.992 5.5 18S11.992 32.5 20 32.5 34.5 26.008 34.5 18 28.008 3.5 20 3.5"
}))));
export default SvgTimeSliderThumb;